import React from 'react';
import 'twin.macro';

interface FullscreenVideoProps {
  src: {
    webm: string;
    mp4: string;
  };
}

const FullscreenVideo: React.FC<FullscreenVideoProps> = ({ src, children }) => (
  <div tw="relative w-full">
    <div tw="relative z-20">{children}</div>
    <video
      autoPlay
      loop
      playsInline
      muted
      tw="w-full h-full absolute -inset-0 z-10 object-cover object-center"
    >
      <source src={src.webm} type="video/webm"></source>
      <source src={src.mp4} type="video/mp4"></source>
    </video>
  </div>
);

export default FullscreenVideo;
